import React from "react";
import { get, isEmpty, size } from "lodash";
import { connect, type ConnectedProps } from "react-redux";
import { FiStar } from "react-icons/fi";
import { auth0AccountSessionSelector } from "store/selectors/auth0";
import { isIndividualAccountOverview } from "store/selectors/user";
import type { RootState } from "types/state";

import Rollover401kProgressiveOnboarding from "./Rollover401kProgressiveOnboarding";
import RolloverAccountStatus from "./RolloverAccountStatus";

// The 401k roll-in portion of the Paychex dashboard, extracted so it can also sit
// above the standard dashboard for people who hold both Paychex products.
const mapStateToProps = (state: RootState) => {
  const accounts = state.accounts.iraAccounts;

  return {
    accounts,
    auth0AccountSessionId: auth0AccountSessionSelector(state),
    isAccountOverview: isIndividualAccountOverview(state),
    isMultiAccount: size(accounts) >= 2,
  };
};

const connector = connect(mapStateToProps);

type Props = ConnectedProps<typeof connector>;

class PaychexRolloverStatus extends React.PureComponent<Props> {
  rolloverAccountStatus = () => {
    const { accounts, auth0AccountSessionId, isMultiAccount } = this.props;
    const filterByAuth0SessionId =
      isMultiAccount && !isEmpty(auth0AccountSessionId);

    const filteredAccounts = filterByAuth0SessionId
      ? accounts.filter((acct) => acct.id === auth0AccountSessionId)
      : accounts;

    return filteredAccounts.map((acct, index) => (
      <RolloverAccountStatus
        key={acct.id || index}
        account={acct}
        // @ts-expect-error IraAccount.accountType is Maybe<string>; RolloverAccountStatus
        // types it as required string (from the original PropTypes.string.isRequired) —
        // pass through unchanged to preserve behavior
        accountType={acct.accountType}
        // @ts-expect-error IraAccount.accountNumber is Maybe<string>; the prop type omits
        // null — pass through unchanged to preserve behavior
        accountNumber={acct.accountNumber}
      />
    ));
  };

  render() {
    const { accounts, auth0AccountSessionId, isAccountOverview } = this.props;

    const showMultiAccountMessage =
      size(accounts) >= 1 && isEmpty(auth0AccountSessionId);

    const allRolloversEmpty = accounts.every((account) =>
      isEmpty(get(account, "rollovers", []))
    );

    if (isAccountOverview && showMultiAccountMessage && allRolloversEmpty) {
      return (
        <Rollover401kProgressiveOnboarding
          icon={<FiStar color="white" stroke="#60A4BF" size={16} />}
          color="primary"
          title={`Your accounts are ready—just one step left.`}
          subheader="To finalize your rollover, go to the Paychex Portal to confirm the transaction. You will receive an email as soon as that is complete."
          disclaimer="There will be a one-time processing fee of $20.00 to set up your account."
        />
      );
    }

    return <>{this.rolloverAccountStatus()}</>;
  }
}

export default connector(PaychexRolloverStatus);
